import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  message,
  Row,
  Space,
  Upload,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import SlideApi from '../../../functions/api/user/SlideApi';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }

  return e && e.fileList;
};

function FormAddSlideShow(props) {
  let history = useHistory();

  async function handleImage(e) {
    let data = new FormData();
    const image = e.originFileObj;
    data.set('photo', image);
    const path = await SlideApi.getPathImage(data);
    return path;
  }

  async function submitForm(values) {
    const path = await handleImage(values.slide_url[0]);
    const payload = { ...values, slide_url: path };
    try {
      await SlideApi.uploadSlidePhoto(payload);
      history.push('/slide');
    } catch (e) {
      message.error(e.message);
    }
  }

  return (
    <>
      <h1>Thêm Slide</h1>
      <Form className="bg-grey" {...formItemLayout} onFinish={submitForm}>
        <Card className="mb-3">
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="slide_url"
                label="Upload"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true }]}
              >
                <Upload listType="picture" beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col span={10}>
              <Form.Item name={['description']} label="Mô tả">
                <TextArea />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['is_active']} valuePropName="checked">
                <Checkbox>Kích hoạt</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Row>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>

            <Button onClick={() => history.push('/slide')} type="default">
              Quay lại
            </Button>
          </Space>
        </Row>
      </Form>
    </>
  );
}
export default withRouter(FormAddSlideShow);
